import { Auth } from '@aws-amplify/auth';
import { captureExceptionWithFullyStory } from '@whitelabel/helpers/utils';
import { xcoverAPI } from '..';

export const userAPI = xcoverAPI.injectEndpoints({
  endpoints: (builder) => ({
    loginUser: builder.mutation({
      queryFn: async ({ email, password }) => {
        try {
          const cognitoUser = await Auth.signIn(email, password);
          return { data: cognitoUser };
        } catch (error: any) {
          captureExceptionWithFullyStory(error);
          return { error: error.message };
        }
      },
    }),
  }),
  overrideExisting: false,
});
